export enum SalesOrderTypeEnum {
  RENT = "Rent",
  ASSET_SALE = "Asset Sale",
  PRODUCT_SALE = "Product Sale",
  TRUCKING = "Trucking",
  OTHERS = "Others",
}
